export default "__VITE_PUBLIC_ASSET__3af01635__"